import { openDialog } from '@/dialogs';
import { setCurrentDateAndView } from '@/scheduler/actions/setCurrentDateAndView';
import { getCurrentRange } from '@/scheduler/selectors/getCurrentViewMode';
import { SCHEDULER_CURRENT_RANGE, SCHEDULER_CURRENT_VIEW } from '@/scheduler/util/cookies';
import { getNearestViewableDate } from '@/scheduler/util/daterangestatus';
import { getPersistedFilter } from '@/scheduler/util/persistFilter';
import {
  DAY_RANGE,
  EMPLOYEE_VIEW,
  MONTH_RANGE,
  TWO_WEEK_RANGE,
  type ViewRange,
  type ViewType,
  WEEK_RANGE,
  WEEK_VIEW,
} from '@/scheduler/util/view';
import { getAuthAccount } from '@/shared/auth/selectors';
import Features from '@/shared/features';
import { EXTENDED_VIEW_UPGRADE_DIALOG } from '@/shared/upsell/actions/dialogs';
import type { WiwDispatch, WiwGetState } from '@/store';

export function navigateToRange(payload: ViewRange) {
  return (dispatch: WiwDispatch, getState: WiwGetState) => {
    const state = getState();
    const currentAccount = getAuthAccount(state);
    const currentDate = state.scheduler.get('currentDate');

    if (
      payload === MONTH_RANGE &&
      (!currentAccount.hasFeature(Features.MONTH_VIEW) || currentAccount.isReverseTrial())
    ) {
      return dispatch(openDialog(EXTENDED_VIEW_UPGRADE_DIALOG));
    }

    if (
      payload === TWO_WEEK_RANGE &&
      (!currentAccount.hasFeature(Features.TWO_WEEK_RANGE) || currentAccount.isReverseTrial())
    ) {
      return dispatch(openDialog(EXTENDED_VIEW_UPGRADE_DIALOG));
    }

    return dispatch(setCurrentDateAndView(getNearestViewableDate(currentAccount, currentDate), undefined, payload));
  };
}

export function navigateToView(payload: ViewType) {
  return (dispatch: WiwDispatch, getState: WiwGetState) => {
    const state = getState();
    const currentRange = getCurrentRange(state);

    if ([DAY_RANGE, MONTH_RANGE].includes(currentRange)) {
      return null;
    }

    const currentAccount = getAuthAccount(state);
    const currentDate = state.scheduler.get('currentDate');

    return dispatch(setCurrentDateAndView(getNearestViewableDate(currentAccount, currentDate), payload));
  };
}

export const getKey = (locationId: number, userId: number) => `${SCHEDULER_CURRENT_VIEW}-${userId}-${locationId}`;

export const getInitialView = () => {
  const filter = getPersistedFilter(SCHEDULER_CURRENT_VIEW, EMPLOYEE_VIEW);

  switch (filter) {
    case WEEK_VIEW:
      return EMPLOYEE_VIEW;
    default:
      return filter;
  }
};

export const getInitialRange = () => getPersistedFilter(SCHEDULER_CURRENT_RANGE, WEEK_RANGE);
